<div class="station-tile another {{style}}"
    [ngClass]="{ 'selected' : selected, 'suspended' : suspended , 'disabled': disabled || style === 'disabled' }"
    [ngStyle]="{ 'height.px': height }"
    >
    <sc-flex fitHeight stretchContent>
        <sc-flex-fitting-content>
            <ng-content></ng-content>
        </sc-flex-fitting-content>
    </sc-flex>
</div>
